module.exports = __webpack_public_path__ + "assets/img/18_1821_big.0a4b9c58.jpg";